class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


$(document).on('click', '.header__icon--cart', function() {
  setTimeout(function(){
    $('.cart-drawer__empty-content').addClass('active-cart-empty-content');
  }, 900);
  setTimeout(function(){
    $('.cart-drawer-cart-notes').addClass('note-cart-active');
  }, 700);
  $('body').addClass('overflow-hidden');
  setTimeout(function(){
   $('.cart-drawer__overlay').addClass('active-cart-open-overlay');
  }, 300);
  setTimeout(function(){
    $('.cart-drawer').addClass('cart-main-content');
  }, 900);
  setTimeout(function(){
    $('.cart-drawer').addClass('main-cart-active');
    $('.drawer').addClass('active-both-drawer');
    if ($('.drawer').hasClass('is-empty')) {
      $('.drawer').removeClass('not-empty-drawer');
    } else {
      $('.drawer').addClass('not-empty-drawer');
    }
    $('.main-cart-drawer-note').addClass('open-menu');
  }, 500);
});

$(document).on('click', '.button-add-to-cart', function() {
  setTimeout(function(){
    $('.cart-drawer__empty-content').addClass('active-cart-empty-content');
  }, 900);
  setTimeout(function(){
    $('.cart-drawer-cart-notes').addClass('note-cart-active');
  }, 1300);
  setTimeout(function(){
      $('.drawer').addClass('add-cart-drawer');
  }, 1300);
  setTimeout(function(){
    $('.cart-drawer').addClass('main-cart-active');
    $('.cart-drawer__overlay').addClass('active-cart-open-overlay');
    $('.drawer').addClass('active-both-drawer');
     $('.drawer').addClass('not-empty-drawer');
    $('body').addClass('overflow-hidden');
    $('.main-cart-drawer-note').addClass('open-menu');
  }, 900);
});


$(document).on('click', '.not-empty-drawer .drawer__close', function() {
   setTimeout(function(){
  $('.cart-drawer__empty-content').removeClass('active-cart-empty-content');
  }, 300);
  setTimeout(function(){
      $('.drawer').removeClass('add-cart-drawer');
  }, 300);
    setTimeout(function(){
      $('.cart-drawer-cart-notes').removeClass('note-cart-active');
    }, 200);
    setTimeout(function(){
      $('.cart-drawer').removeClass('main-cart-active');;
      $('.main-cart-drawer-note').removeClass('open-menu');
    }, 800);
    setTimeout(function(){
      $('.cart-drawer').removeClass('cart-main-content');
    }, 600);
     if ($('.drawer').hasClass('is-empty')) {
      $('.drawer').removeClass('not-empty-drawer');
    }
    setTimeout(function(){
      $('.cart-drawer__overlay').removeClass('active-cart-open-overlay');
      $('.drawer').removeClass('active-both-drawer');
      $('.drawer').removeClass('not-empty-drawer');
      $('.main-cart-drawer-note').removeClass('open-menu');
    }, 1000);
  setTimeout(function(){
      $('body').removeClass('overflow-hidden');
   }, 1600);
});

$(document).on('click', '.is-empty .drawer__close', function() {
    setTimeout(function(){
      $('.drawer').removeClass('add-cart-drawer');
      $('.cart-drawer-cart-notes').removeClass('note-cart-active');
      $('.cart-drawer').removeClass('main-cart-active');;
      $('.main-cart-drawer-note').removeClass('open-menu');
      $('.cart-drawer').removeClass('cart-main-content');
      $('.drawer').removeClass('active-both-drawer');
      $('.drawer').removeClass('not-empty-drawer');
      $('.main-cart-drawer-note').removeClass('open-menu');
    }, 200);
    setTimeout(function(){
      $('.cart-drawer__overlay').removeClass('active-cart-open-overlay');
    }, 400);
    $('.cart-drawer__empty-content').removeClass('active-cart-empty-content');
    setTimeout(function(){
      $('body').removeClass('overflow-hidden');
    }, 600);
    if ($('.drawer').hasClass('is-empty')) {
      $('.drawer').removeClass('not-empty-drawer');
    }
}); 

$(document).on('click', '.clear-all-text', function() {
    $('.drawer').removeClass('not-empty-drawer');
    setTimeout(function(){
      $('.cart-drawer__empty-content').addClass('active-cart-empty-content');
    }, 900);
});


$(document).mouseup(function (e) {
     var container = $('.main-cart-drawer-note');
     if (!container.is(e.target) && container.has(e.target).length === 0 && $('.main-cart-drawer-note').hasClass('open-menu')) {
          setTimeout(function(){
            $('.cart-drawer-cart-notes').removeClass('note-cart-active');
          }, 200);
          setTimeout(function(){
            $('.cart-drawer').removeClass('main-cart-active');;
            $('.main-cart-drawer-note').removeClass('open-menu');
          }, 400);
          setTimeout(function(){
            $('.cart-drawer').removeClass('cart-main-content');
          }, 300);
          setTimeout(function(){
            $('.cart-drawer__overlay').removeClass('active-cart-open-overlay');
            $('.drawer').removeClass('active-both-drawer');
            $('.drawer').removeClass('not-empty-drawer');
            $('.main-cart-drawer-note').removeClass('open-menu');
          }, 600);
        setTimeout(function(){
            $('body').removeClass('overflow-hidden');
         }, 1400);
     }
 });